<template>
    <div class="app-left-margin w-100" style="padding-right: 75px;">
        <d-inbox
            v-model="showInbox"
        />

        <d-inc-outbox
            v-model = "showOutbox"
        />

        <v-app-bar color="white" elevation="0"  height="45">
            <v-app-bar-nav-icon
                @click = "drawer=true"
                class  = "primary--text"
                style  = "margin-top: -2px"
            />

            <v-toolbar-title class="primary--text"><span>LIFTMANAGER</span><span v-if="!isProd" class="ml-3 red--text" style="font-weight: normal">(Testsystem)</span></v-toolbar-title>

            <div class="v-flex ml-5 mr-3" style="height: 32px; ">
                <c-toolbar-button
                    icon     = "mdi-home"
                    :color   = "style.color"
                    :size    = "style.size"
                    :tooltip = "$t('home.button')"
                    @click   = "onHome"
                />

                <c-app-recent-incident
                    v-if = "liftmanager"
                />

                <c-app-recent-site
                    v-if = "liftmanager"
                />

                <c-toolbar-button
                    v-if     = "liftmanager"
                    icon     = "mdi-inbox"
                    :color   = "style.color"
                    :size    = "style.size"
                    :tooltip = "$t('inb.button.messages')"
                    @click   = "onInbox"
                />

                <c-toolbar-button
                    v-if     = "liftmanager"
                    icon     = "mdi-inbox-arrow-up"
                    :color   = "style.color"
                    :size    = "style.size"
                    tooltip  = "Outbox"
                    @click   = "onOutbox"
                />

                <!--
                <c-toolbar-button
                    v-if     = "liftmanager"
                    icon     = "mdi-calendar-week"
                    :color   = "style.color"
                    :size    = "style.size"
                    :tooltip = "$t('crm.button.week')"
                    @click   = "onCalendar"
                />
                -->
            </div>

            <c-app-home-search
                :categories = "['site', 'incident']"
                :search-on-focus = "searchOnFocus"
            />

            <v-spacer/>

            <div class="float-right" style="display: flex">
                <crm-top-reminder-menu
                    v-if="liftmanager"
                    v-model="reminder"
                />

                <inb-message-menu
                    v-if="liftmanager"
                    v-model="messages"
                />

                <c-inc-clipboard-menu
                    v-if="liftmanager"
                    v-model="clipboard"
                />

                <nav-user-menu />
            </div>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
        >
            <c-app-side-drawer
                :show="drawer"
            />
        </v-navigation-drawer>

        <v-navigation-drawer
            v-model = "messages"
            :left   = "!drawerRight"
            :right  = "drawerRight"
            width   = "500"
            hide-overlay
            stateless
            absolute
            temporary
        >
            <inbox-message-drawer
                :open="messages"
                @close="onClose"
                @position="onPosition"
            />
        </v-navigation-drawer>

        <v-navigation-drawer
            v-model = "reminder"
            width   = "500"
            :left   = "!drawerRight"
            :right  = "drawerRight"
            absolute
            temporary
        >
            <crm-reminder-drawer
                @close="onClose"
                @position="onPosition"
            />
        </v-navigation-drawer>

        <v-navigation-drawer
            v-model = "clipboard"
            width   = "500"
            :left   = "!drawerRight"
            :right  = "drawerRight"
            hide-overlay
            stateless
            absolute
            temporary
        >
            <c-inc-clipboard-drawer
                @close    = "onClose"
                @position = "onPosition"
            />
        </v-navigation-drawer>
    </div>
</template>

<script>

import Core                from "@/modules/core/service/Core";
import Inb                 from "@/modules/inb/service/Inb.js";
import CAppHomeSearch      from "@/modules/core/components/app/CAppHomeSearch";
import CrmTopReminderMenu  from "@/modules/crm/components/nav/CrmReminderMenu";
import InbMessageMenu      from "@/modules/inb/components/nav/InbMessageMenu";
import CAppSideDrawer      from "@/modules/core/components/app/CAppSideDrawer";
import NavUserMenu         from "@/modules/msd/user/components/nav/NavUserMenu";
import CAppRecentIncident  from "@/modules/core/components/app/CAppRecentIncident";
import InboxMessageDrawer  from "@/modules/inb/components/nav/InbMessageDrawer";
import CrmReminderDrawer   from "@/modules/crm/components/nav/CrmReminderDrawer";
import CToolbarButton      from "@/modules/core/components/utils/CToolbarButton";
import CAppRecentSite      from "@/modules/core/components/app/CAppRecentSite";
import CIncClipboardMenu   from "@/modules/inc/steps/components/common/clipboard/CIncClipboardMenu.vue";
import CIncClipboardDrawer from "@/modules/inc/steps/components/common/clipboard/CIncClipboardDrawer.vue";
import DInbox              from "@/modules/inb/components/main/DInbox";
import DIncOutbox          from "@/modules/inc/outbox/components/DIncOutbox.vue";

export default {
    name: "CAppHomeBar",

    components: {
        DIncOutbox,
        DInbox,
        CIncClipboardDrawer,
        CIncClipboardMenu,
        CAppRecentSite,
        CToolbarButton,
        CrmReminderDrawer,
        InboxMessageDrawer,
        CAppRecentIncident,
        CAppHomeSearch,
        CAppSideDrawer,
        NavUserMenu,
        InbMessageMenu,
        CrmTopReminderMenu,
    },

    props: {
        searchOnFocus: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        /**
         * Controls the visability of the inbox dialog.
         */
        showInbox: false,
        showOutbox: false,

        drawer     : false,
        messages   : false,
        clipboard  : false,
        reminder   : false,
        draged     : false,
        drawerRight: true,
        refresh    : 0,
        style: {
            size : 22,
            color: "primary"
        }
    }),

    computed: {
        liftmanager() {
            return Core.role.liftmanager();
        },
        isProd () {
            return Core.role.prod();
        }
    },

    methods: {
        onHome () {
            Core.nav.home(this);
        },

        onInbox () {
            this.showInbox = true;
        },

        onOutbox () {
            this.showOutbox = true;
        },

        onCalendar () {
            this.$bus.$emit(Inb.event.refresh);
            Core.nav.push(this, "calendar");
        },

        onClose () {
            this.reminder = false;
            this.messages = false;
            this.clipboard= false;
        },

        onPosition (value) {
            this.drawerRight = value;
        },

    }
}
</script>

<style scoped>
::v-deep .v-overlay__scrim {
    opacity: 0.0!important;
    color: white;
}

::v-deep .v-toolbar__content,
::v-deep .v-toolbar__content i {
    font-size: 15pt;
    padding: 0;
}

::v-deep .v-toolbar__title {
    font-weight: 700;
    padding-left: 0!important;
    font-size: 15pt;
}


.nav-search-input input {
    outline: none;
    width: 100%;
}

::v-deep .v-btn__content {
    align-items: start;
}

::v-deep .v-menu__content {
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
    min-width: 16rem !important;
}

.nav-search-icon i {
    color: gray;
    font-size: 13pt;
}

::v-deep .v-navigation-drawer__content {
    overflow: hidden;
}

</style>